import React, { useCallback, useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import _get from 'lodash/get';
import _omit from 'lodash/omit';
import queryString from 'query-string';

import { useHistory, useLocation } from 'react-router';
import * as Types from 'pages/Pages/typings';

import InfoIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import InfoCard from 'pages/Invites/components/Users/InfoCard';

interface Filter {
  id: string;
  count: number;
  query: {
    filterOn: string;
  };
}

interface Props {
  pagesData: Types.EntitySearchResult;
}

function PagesCards({ pagesData }: Props) {
  const classes = useStyles();
  const { search } = useLocation();
  const history = useHistory();
  let query = queryString.parse(search) as any;
  const [filterName, setFilterName] = useState<'edited' | 'unedited' | null>(query.filterOn);
  const filters = _get(pagesData, 'filters', []);
  const editedFilter = filters.find((filter: Filter) => filter.id === 'edited');
  const uneditedFilter = filters.find((filter: Filter) => filter.id === 'unedited');
  const allFilter = filters.find((filter: Filter) => filter.id === 'all');

  const handleFilterChange = useCallback(
    (newFilterName: 'edited' | 'unedited' | null) => {
      setFilterName(newFilterName);

      if (newFilterName) {
        query.filterOn = newFilterName;
      } else {
        query = _omit(query, 'filterOn');
      }

      history.push({ pathname: history.location.pathname, search: queryString.stringify(query) });
    },
    [query, history],
  );

  return (
    <div className={classes.pagesCards}>
      <InfoCard
        className={classes.marginRight3}
        description="All Pages"
        number={_get(allFilter, 'count', '-')}
        selected={!filterName}
        onClick={() => handleFilterChange(null)}
      />
      <InfoCard
        className={classes.marginRight3}
        description={
          <div className={classes.infoCardDescription}>
            Edited Pages
            <Tooltip
              arrow={true}
              title="At least one attribute on these pages has been edited."
              placement="top"
            >
              <InfoIcon data-testid="edited-info" className={classes.infoIcon} />
            </Tooltip>
          </div>
        }
        number={_get(editedFilter, 'count', '-')}
        selected={filterName === 'edited'}
        onClick={() => handleFilterChange('edited')}
      />
      <InfoCard
        className={classes.marginRight3}
        description={
          <div className={classes.infoCardDescription}>
            Unedited Pages
            <Tooltip
              arrow={true}
              title="No one has edited any attributes on these pages."
              placement="top"
            >
              <InfoIcon data-testid="unedited-info" className={classes.infoIcon} />
            </Tooltip>
          </div>
        }
        number={_get(uneditedFilter, 'count', '-')}
        selected={filterName === 'unedited'}
        onClick={() => handleFilterChange('unedited')}
      />
    </div>
  );
}

const useStyles = makeStyles((theme: any) => ({
  infoIcon: {
    marginLeft: theme.spacing(),
    color: theme.colors.gray1,
  },
  marginRight3: {
    marginRight: theme.spacing(3),
  },
  infoCardDescription: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pagesCards: {
    display: 'flex',
    marginTop: theme.spacing(3),
  },
}));

export default PagesCards;
